module.exports = __webpack_public_path__ + "images/interview-McKinsey_and_Company-2.svg";